import { motion } from "framer-motion";
import { useLanguage } from "@/contexts/LanguageContext";
import { getTranslation } from "@/lib/translations";
import shopifyPartnersLogo from "@/assets/badges/shopify-partners-primary.svg";
import googleCloudLogo from "@/assets/badges/google-cloud-partner.svg";
import webflowBadge from "@/assets/badges/webflow-certified-blue.svg";
import kinstaBadge from "@/assets/badges/kinsta-partner.svg";

const CLIENTS = [
  "Amber Oud",
  "AlQabas",
  "Shasha",
  "Kuwait News",
  "Your Ceramic Store",
  "Rasameel",
  "Alshaya Perfumes",
  "NBK",
];

const PARTNER_LOGOS = [
  {
    name: "Shopify Partners",
    logo: shopifyPartnersLogo,
    link: "https://www.shopify.com/partners/directory/partner/wavai-technology-llc",
  },
  {
    name: "Webflow Certified Partner",
    logo: webflowBadge,
    link: "/webflow",
    external: false,
  },
  {
    name: "Google Cloud Partner",
    logo: googleCloudLogo,
    link: "https://cloud.google.com/find-a-partner/partner/wavai-technology",
  },
  {
    name: "Kinsta Agency Partner",
    logo: kinstaBadge,
    link: "https://kinsta.com",
  },
];

export function ClientLogos() {
  const { lang } = useLanguage();
  const t = (key: string) => getTranslation(key, lang);

  return (
    <section className="py-12 lg:py-32 border-b border-border">
      <div className="container px-6">
        {/* Trusted By — Client Names */}
        <motion.p
          className="text-xs uppercase tracking-[0.2em] text-muted-foreground font-medium text-center mb-8"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          {t("Trusted By")}
        </motion.p>

        <motion.div
          className="flex items-center gap-6 lg:gap-10 overflow-x-auto lg:overflow-visible lg:flex-wrap lg:justify-center pb-2 lg:pb-0 scrollbar-hide mb-16"
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.1 }}
        >
          {CLIENTS.map((name) => (
            <div
              key={name}
              className="flex-shrink-0 flex items-center justify-center px-6 py-3 rounded-lg border border-border bg-card text-sm font-semibold text-foreground/50 hover:text-foreground hover:border-primary/30 transition-all duration-300 select-none min-w-[120px]"
            >
              {name}
            </div>
          ))}
        </motion.div>

      </div>
    </section>
  );
}
